module.exports = __webpack_public_path__ + "img/screen-6.6ecc2369.png";